// extracted by mini-css-extract-plugin
export default {"wrapper":"T545ZpRA","mobile":"mobile","instagram-media":"instagram-media","leftSnippet":"Hq5lX5hr","rightSnippet":"V2S92cHN","divider":"sMyiUDew"};